import { render, staticRenderFns } from "./StatIndex.vue?vue&type=template&id=9c6eac28&scoped=true&"
import script from "./StatIndex.vue?vue&type=script&lang=js&"
export * from "./StatIndex.vue?vue&type=script&lang=js&"
import style0 from "./StatIndex.vue?vue&type=style&index=0&id=9c6eac28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6eac28",
  null
  
)

export default component.exports